import { render, staticRenderFns } from "./FinishGoodQualityInspectionNgUpload.vue?vue&type=template&id=b2fafa2e&"
import script from "./FinishGoodQualityInspectionNgUpload.vue?vue&type=script&lang=js&"
export * from "./FinishGoodQualityInspectionNgUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports